import React, { Component } from 'react'
import { getURLParameters } from './../lib/utils'
import i18n from 'i18next'
import logo from '../img/logo.png'
import './Header.css'

class Header extends Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = ({
            lang: this.props.lang,
            fontSize: "Larger",
        })
        this.openNewWindow = this.openNewWindow.bind(this)
    }

    openNewWindow = () => {
        var lang = getURLParameters('lang')
        var cc = getURLParameters('cc')
        window.open('/bochkfxibs/contactus?lang='+lang+'&cc='+cc, '_blank', " left=50%, top=50%, width=1024, height=780, scrollbars=1");
    }

    fontSizeConvertor(fontSize: string) {
        if (fontSize === "Normal") {
            return "80%"
        } else if (fontSize === "Larger") {
            return "100%"
        } else if (fontSize === "Largest") {
            return "130%"
        } else {
            return "100%"
        }
    }


    convertlang(lang: string) {
        if (lang === "sc") {
            return "zh_CN"
        } else if (lang === "tc") {
            return "zh_HK"
        } else if (lang === "en") {
            return "en"
        } else {
            return "zh_HK"
        }
    }

    changeLang(tochangelang: string) {
        this.setState({
            lang: tochangelang
        })
        this.props.setlang(tochangelang)
    }

    changeFontSize(fontSize: string) {
        this.setState({
            fontSize: fontSize
        })

        const size = this.fontSizeConvertor(fontSize)
        this.props.setfontsize(size)
    }

    newWindowUnloaded() {
        this.setState({ isModalOpen: false })
    }

    render() {
        return (
            <div className="App-Header">
                <div className="header-top">
                    <div className="logo">
                        <img className="logo" src={logo} alt="BOC" />
                    </div>
                    <ul className="nav-top">
                        <li>
                            <div className="lang">
                                <div onClick={() => this.changeLang(i18n.t("Common.Lang1Index"))}>
                                    {i18n.t("Common.Lang1")}
                                </div>
                                <div onClick={() => this.changeLang(i18n.t("Common.Lang2Index"))}>
                                    {i18n.t("Common.Lang2")}
                                </div>
                            </div>

                        </li>
                        <li>
                            <div className="contact" onClick={this.openNewWindow}>{i18n.t("Common.Contact")}</div>
                        </li>
                        <li>
                            <div className="fontsize">
                                <div className={"font" + (this.state.fontSize === "Normal" ? " selected" : "")} style={{ fontSize: this.fontSizeConvertor('Normal') }} onClick={() => this.changeFontSize("Normal")}><span />A<span /></div>
                                <div className={"font" + (this.state.fontSize === "Larger" ? " selected" : "")} style={{ fontSize: this.fontSizeConvertor('Larger') }} onClick={() => this.changeFontSize("Larger")}><span />A<span /></div>
                                <div className={"font" + (this.state.fontSize === "Largest" ? " selected" : "")} style={{ fontSize: this.fontSizeConvertor('Largest') }} onClick={() => this.changeFontSize("Largest")}><span />A<span /></div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="separator">
                    <div className="separator-red"></div>
                </div>
            </div>
        )
    }
}

export default Header